import * as React from 'react'
import styles from './style.module.css';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Schedule from '../../Schedule';
import { useLocalServices } from '../../../../../../../hooks';
import { Edit_Travel_Operate_Changed, Edit_Travel_set_pickup, EditOrder_Pickup_setCustomField, Set_Pickup_Inputs } from '../../../../../../../Redux/actions/actionNames';
import { ARROW_DOWN, Attach, calendar_gray, calendar_time_gray, CLOSE, email_icon, hashtag2, INFO_CIRCLE, input, list_gray } from '../../../../../../../assets';
import Typography from '../../../../../../../design-system/lib/Typography';
import Input from '../../../../../../../design-system/lib/Input';
import Button from '../../../../../../../design-system/lib/Button';
import PhoneInput from '@onro/react-phone-input-2'
import '@onro/react-phone-input-2/lib/style.css'
import IconProvider from '../../../../../../../design-system/lib/IconProvider';
import Address_details_Icon from '../../../../../../../assets/IconProvider/address_details_color.svg'
import ArrowDown from '../../../../../../../assets/IconProvider/Arrow---Down-2.svg'
import address_details from '../../../../../../../assets/IconProvider/address_details.svg'
import email_x from '../../../../../../../assets/IconProvider/email_x.svg'
import notes_X from '../../../../../../../assets/IconProvider/notes_X.svg'
import person_x from '../../../../../../../assets/IconProvider/person_x.svg'
import CustomField_Input from '../../../../../../../CustomFields/Input';
import CustomField_Phone from '../../../../../../../CustomFields/phone';
import EllipisWithTooltip from '../../../../../../../design-system/lib/ellipsis-with-tooltip';
import CustomField_MultiLine from '../../../../../../../CustomFields/multiLine';
import Toggle from '../../../../../../../design-system/lib/toggle';
import CustomField_DropDown from '../../../../../../../CustomFields/DropDown';
import CustomField_Date from '../../../../../../../CustomFields/Date';
import jalali from "jalali-moment";
import { checkTimestamp, get_dateFormat, get_lang } from '../../../../../../../helper/UserData/userdate';
import CustomField_DateTime from '../../../../../../../CustomFields/DateTime';
import CustomField_file from '../../../../../../../CustomFields/file';
import TooltipOnro from '../../../../../../../design-system/lib/Tooltip';
import Radiobutton from '../../../../../../../design-system/lib/Radiobutton';
import { isEmpty } from 'lodash';
import { getDropDownCustomFieldText } from '../../../../../../../components/new-order/customer/components/edit-customer';




function ItemsList(data, currentState, setCurrentState) {
  return (
    <div className={styles.itemsConatiner}>
      {data.map((item) => {
        return <div onClick={() => { setCurrentState(item) }}>
          <Radiobutton size="Small" state={(currentState == item.id || currentState == item.title) ? "checked" : "unchecked"} onClick={() => { }} />
          {item.icon && <img src={item.icon} />}
          <Typography weight={(currentState == item.id || currentState == item.title) ? 'Body_Middle_Bold' : 'Body_Middle_Regular'} textColor={'TextNormal'} text={item.title} className={(currentState == item.id || currentState == item.title) ? styles.dropItemchecked : styles.dropItemUnchecked} />

        </div>
      })}
    </div>
  )
}



function PickupInfoEditOrder({ handleShowInfo, pickupRequiredCheck , collapsed, showRequirdalert }) {
  const serviceId = useSelector((state) => state.ViewTravel.pureData.service.id)
  const serviceactiveVehicleType = useSelector((state) => state.EditOrder.editOrder.service.activeVehicleType)

  const addressDetail = useSelector((state) => state.EditOrder.editOrder.pickup.addressDetail)
  const floor = useSelector((state) => state.EditOrder.editOrder.pickup.floor)
  const unit = useSelector((state) => state.EditOrder.editOrder.pickup.room)
  const email = useSelector((state) => state.EditOrder.editOrder.pickup.email)
  const senderFullName = useSelector((state) => state.EditOrder.editOrder.pickup.fullName)
  const senderPhoneNumber = useSelector((state) => state.EditOrder.editOrder.pickup.phone)
  const ActivescheduleSetting = useSelector((state) => state.ViewTravel.pureData?.deliveryMethod?.scheduleSetting?.isActive)
  const deliveryMethod = useSelector((state) => state.ViewTravel.pureData?.deliveryMethod)

  const scheduleDateBefore = useSelector((state) => state.EditOrder.editOrder.pickup.scheduleDateBefore)
  const scheduleDateAfter = useSelector((state) => state.EditOrder.editOrder.pickup.scheduleDateAfter)
  const orderTypeActive = useSelector((state) => state.ViewTravel.pureData.type)
  const block = useSelector((state) => state.EditOrder.editOrder.pickup.buildingBlock)
  const noteForDriver = useSelector((state) => state.EditOrder.editOrder.pickup.customerDescription)
  const customField = useSelector((state) => state.EditOrder.editOrder.pickup.customField) || {}

   const orderCustomFieldDefinitions = useSelector((state) => state.ViewTravel.pureData?.pickup?.customFieldDefinitions ) || []
   const ordercustomFields = useSelector((state) => state.ViewTravel.pureData?.pickup?.customFields)

  const { t, i18n } = useTranslation();

  //  const [customFields, setCustomFields] = React.useState(ordercustomFields);

  const dispatch = useDispatch();


  
  function hasCustomFieldError(fieldKey, definitions, customField, t) {
    const field = definitions.find(f => f.key === fieldKey);
    if (!field) return false;

    const value = customField[field.key];
    const config = field.config;

    const isEmptyx =
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    if (!field.isRequired && isEmptyx) return false;

    if (field.isRequired && isEmptyx) {
      return false
    }

    // TEXT
    if (config.type === "singleLine" || config.type === "multiLine") {
      if (typeof value !== "string") {
        return t("custominvalid");
      }

      if (config.minLength && value.length < config.minLength ) {
        return t("customminLength", { min: config.minLength });
      }

      if (config.maxLength && value.length > config.maxLength) {
        return t("custommaxLength", { max: config.maxLength });
      }

      if (config.pattern && !new RegExp(config.pattern).test(value)) {
        return t("custompattern");
      }
    }

    // EMAIL
    if (config.type === "email") {
      if (!/^\S+@\S+\.\S+$/.test(value)) {
        return t("customemail");
      }
    }

    // PHONE
    if (config.type === "phone") {
      if (value.toString().length < 7) {
        return t("customphone");
      }
    }

    // NUMBER
    if (config.type === "number") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });
      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }
    }

    // DECIMAL


    if (config.type === "decimalNumber") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });

      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }

      if (config.precision !== undefined) {
        const decimals = value.toString().split(".")[1];
        if (decimals && decimals.length > config.precision) {
          return t("customdecimalPrecision", { p: config.precision });
        }
      }
    }



    // SELECT
    if (config.type === "select") {
      const allowed = config.choices.map(c => c.key);
      if (!allowed.includes(value)) {
        return t("customselect");
      }
    }

    // FILE
    if (config.type === "file") {

      if (value.url) {

      } else {
        if (!(value instanceof File)) {
          return t("customfileInvalid");
        }

        const sizeMB = value.size / (1024 * 1024);
        if (sizeMB > config.maxSizeMB) {
          return t("customfileSize", { max: config.maxSizeMB });
        }

        if (
          config.allowedTypes?.length &&
          !config.allowedTypes.includes(value.type)
        ) {
          return t("customfileType");
        }
      }

    }

    // DATE
    if (config.type === "date" || config.type === "dateTime") {
      if (isNaN(new Date(value).getTime())) {
        return t("customdate");
      }
    }

    return false;
  }


  
  function renderCustomField(
    field,
    value,
    onChange
  ) {
    switch (field.config.type) {
      case 'phone':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , display:"flex" ,fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}>  <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Phone  error={hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t)}  value={customField[field.key] || ""} hint={field?.label} inputType="number" onChange={(e) => {

             dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: e }))

            }}  style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}} />

 
         
         
          </div>
        );

      case 'singleLine':
           return (
          <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}>  <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t)}   value={customField[field.key] || ""} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: e  }))

            }}   style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}}/>

 
         
         
          </div>
        );
      case 'email':
         
        return (
          <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}>  <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t)}   value={customField[field.key] || ""} config={field.config} icon={email_icon} hint={field?.label} inputType="text" onChange={(e) => {
              dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: e  }))

            }}   style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}}/>

 
         
         
          </div>
        );
      case 'number':
      case 'decimalNumber':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}>  <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t)}   defvalue={customField[field.key] || ""} config={field.config} icon={hashtag2} hint={field?.label} inputType="number" onChange={(e) => {
               dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: e }))


            }}   style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}}/>

 
         
         
          </div>
        );

      case 'multiLine':
        return (
          <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}>  <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_MultiLine   error={hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t)}   value={customField[field.key] || ""} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
             dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: e?.target.value }))

            }}   style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}}/>

 
         
         
          </div>
        );

      case 'boolean':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ 
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}>
              <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}  {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
           </span>
            <Toggle isActive={customField[field.key] || false} setIsHover={(e) => {
              dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: !(customField[field.key] || false) }))

            }} />
          </div>
        );

      case 'select':
        return (

          <div className={styles.OptionsRow}>
            <span style={{ 
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}>
              <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span> {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_DropDown   error={hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t)}   icon={list_gray}
              ItemsList={ItemsList(field?.config?.choices.map((item) => { return { title: item.label, data: item, id: item.key } }), customField[field.key], (JOJO) => {
               dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: JOJO.id }))


              })} textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? getDropDownCustomFieldText(field?.config?.choices , customField[field.key]) : field?.label} placement={'bottomStart'}
              data={field?.config?.choices} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => {
                 dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: null }))
              }}   style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}}/>

 
         
         
          </div>

        );

      case 'date':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex",
              flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> </span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Date icon={calendar_gray}
              textStyle={styles.DropDownTextStyle} size='Small'
              text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${get_dateFormat()}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")} onChange={(JOJO) => {
               dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: JOJO }))


              }}
              isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }}  style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}} />

 
         
         

          </div>
        );

      case 'dateTime':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row",
              justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_DateTime icon={calendar_time_gray}
              textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(customField[field.key]))}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")}
              onChange={(JOJO) => {
               dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: JOJO }))


              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }}   style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}}/>

 
         
         

          </div>

        );

      case 'file':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip>
            </span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_file   error={hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t)}   config={field.config} icon={Attach} inputType={"file"}
              textStyle={styles.DropDownTextStyle} size='Small' text={field?.label} placement={'bottomStart'} defValue={customField[field.key]?.name}
              requiredText={t("Required")} onChange={(JOJO) => {
                dispatch(EditOrder_Pickup_setCustomField({ key: field.key, value: JOJO }))


              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }}   style={{ borderColor: hasCustomFieldError(field.key, orderCustomFieldDefinitions, customField, t) ? "red" : ""}}/>

 
         
         

          </div>
        );


      default:
        return null;
    }
  }


  const closeDialoge = () => {
    handleShowInfo()
  };

  

  const Emailvalidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }


  const handlePickUpInputs = (e, name) => {
    dispatch(Edit_Travel_Operate_Changed());

    dispatch(
      Edit_Travel_set_pickup({
        [name]: e ,
      })
    );


  };

  const phoneNumberOnChange = (res, id) => {
    dispatch(Edit_Travel_Operate_Changed());

    dispatch(
      Edit_Travel_set_pickup({
        [id]: res
      })
    );
  };

  const detectOrderType = React.useCallback(() => {

    if (serviceactiveVehicleType && serviceactiveVehicleType.orderTypes?.indexOf("PickupDelivery") > -1) {
      return "PickupDelivery"
    } else {
      return "Ondemand"
    }

  }, [serviceactiveVehicleType])



  const GetDetailsInputtoText = React.useCallback(() => {

    let xxx = ""

    if (addressDetail && String(addressDetail).trim().length > 0 && (deliveryMethod?.setting?.isAddressDetailsActive && detectOrderType() == "PickupDelivery")) {
      String(xxx).length > 0 ? xxx += `, ${addressDetail}` : xxx += `${addressDetail}`;
    }

    if (block && String(block).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${block}` : xxx += `${block}`
    }

    if (floor && String(floor).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${floor}` : xxx += `${floor}`
    }

    if (unit && String(unit).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${unit}` : xxx += `${unit}`
    }

    if (email && String(email).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${email}` : xxx += `${email}`
    }


    if (senderFullName && String(senderFullName).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderFullName}` : xxx += `${senderFullName}`
    }


    if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderPhoneNumber}` : xxx += `${senderPhoneNumber}`
    }



    if (noteForDriver && String(noteForDriver).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${noteForDriver}` : xxx += `${noteForDriver}`
    }

    return xxx

  }, [addressDetail, block, floor, unit, email, senderFullName, senderPhoneNumber, noteForDriver, serviceactiveVehicleType])


  if (!deliveryMethod?.setting?.isPickupAddressPhoneActive && !(deliveryMethod?.setting?.isPickupAddressEmailActive) && orderTypeActive == "PickupDelivery" && !deliveryMethod?.setting?.isPickupAddressNameActive && !(deliveryMethod?.setting?.isPickupAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && !(deliveryMethod?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery") || ( !showRequirdalert && !collapsed)) {
    return null
  }


  console.log("dfefedf ",orderCustomFieldDefinitions)

  return (
    <div className={styles.NewCustomerRegisterContainer} >
      

      {( showRequirdalert && !collapsed) && <Typography text={t("CompleteRequiredFeileds")} weight='Body_Small_Regular' style={{
        width: "345px", overflow: 'hidden',
        textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", marginTop: "0px"
      }} textColor='Red' />}


      {collapsed && <div className={styles.collapsed}>

        <div className={styles.titleOptionsRow} >
          <Typography text={t("Details")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>


          {/* singleLine */}
        {deliveryMethod?.setting?.isPickupAddressNameActive && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("Fullname")}  {deliveryMethod?.setting?.isPickupAddressNameRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("Fullname")} defvalue={senderFullName} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "fullName")

          }} />
        </div>}

        
        {/* phone */}
        {deliveryMethod?.setting?.isPickupAddressPhoneActive && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("Phonenumber")}  {(serviceactiveVehicleType && serviceactiveVehicleType.setting && serviceactiveVehicleType.setting.isPickupAddressPhoneRequired) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

          </span>
          <CustomField_Phone value={senderPhoneNumber} hint={t("Phonenumber")} inputType="number" onChange={(e) => {
            phoneNumberOnChange(e, "phone")

          }} />
        </div>}



        {/* email */}
        {(deliveryMethod?.setting?.isPickupAddressEmailActive) && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("email")}  {deliveryMethod?.setting?.isPickupAddressEmailRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

          </span>
          <CustomField_Input config={{
            "type": "email"
          }} icon={email_icon} hint={t("email")} inputType="text" defvalue={email} onChange={(e) => {
            phoneNumberOnChange(e, "email")

          }} />
        </div>}


        {/* singleLine */}
        {(deliveryMethod?.setting?.isPickupAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("block")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("block")} defvalue={block} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "buildingBlock")

          }} />
        </div>}

        {/* singleLine */}
        {(deliveryMethod?.setting?.isPickupAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("floor")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("floor")} defvalue={floor} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "floor")

          }} />
        </div>}

        {/* singleLine */}
        {(deliveryMethod?.setting?.isPickupAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("Unit")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("Unit")} defvalue={unit} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "room")

          }} />
        </div>}


        {/* singleLine */}
        {(deliveryMethod?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("addressDetail")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={address_details} hint={t("addressDetail")} defvalue={addressDetail} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "addressDetail")

          }} />
        </div>}


        {/* singleLine */}
        {(orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("notesfordriver")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={notes_X} hint={t("notesfordriver")} defvalue={noteForDriver} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "customerDescription")

          }} />
        </div>}


             {(orderCustomFieldDefinitions.filter((item) => { return item.stage == "pickup" }).length > 0) && <div className={styles.titleOptionsRow} >
          <Typography text={t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>}



        {orderCustomFieldDefinitions.filter((item) => { return item.stage == "pickup" }).map(field =>
          renderCustomField(field, "")
        )}


        


 

      </div>}



    </div>
  )
}

export default PickupInfoEditOrder